import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSEO } from '../../utils/seo';

interface Candidate {
  id: number;
  name: string;
  position: string;
  age: number;
  profession: string;
  image: string;
  description: string;
}

const KandidatenPage = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  const [hoveredCandidate, setHoveredCandidate] = useState<number | null>(null);

  const stadtratCandidates: Candidate[] = [
    {
      id: 1,
      name: "Dennis Neumeister",
      position: "Spitzenkandidat",
      age: 26,
      profession: "Bauzeichner, Student Bauingenieurwesen",
      image: "https://le-cdn.website-editor.net/f4f5b2f6065c4ec2b536c829d952713f/dms3rep/multi/opt/Dennis+Neumeister-1920w.jpg",
      description: "Ich bin 26 Jahre alt, gelernter Bauzeichner und studiere derzeit Bauingenieurwesen neben meiner Tätigkeit in einem Planungsbüro. Meine Zeit im Internat sowie der freiwillige Wehrdienst bei der Bundeswehr haben mich geprägt und mir früh vermittelt, wie wichtig Teamfähigkeit, Disziplin und Verlässlichkeit sind. Als Spitzenkandidat möchte ich mich im Stadtrat für eine traditionsreiche, familienfreundliche und lebendige Stadt einsetzen. Für mich stehen Verantwortung und Transparenz im Mittelpunkt politischen Handelns. Gemeinsam möchte ich mit Ihrem Vertrauen die Region stärken und mutig die Herausforderungen von morgen angehen. Veränderung beginnt nicht nur in Berlin, sondern auch hier bei uns. Lasst uns zusammen vor Ort etwas bewegen!"
    },
    {
      id: 2,
      name: "Monika Hartmann",
      position: "Kandidatin",
      age: 39,
      profession: "Verkäuferin",
      image: "https://le-cdn.website-editor.net/f4f5b2f6065c4ec2b536c829d952713f/dms3rep/multi/opt/Monika+Hartmann-1920w.jpg",
      description: "Ich bin in Bad Windsheim geboren und lebe - bis auf zwei Jahre - schon mein ganzes Leben hier. Ich bin verheiratet und habe zwei jugendliche Kinder. Unsere Stadt ist mein Zuhause. Ich möchte mit anpacken, Probleme offen ansprechen und dafür sorgen, dass unsere Stadt sich ehrlich, transparent und sinnvoll weiterentwickelt. Hier ist in den letzten Jahren viel Gutes entstanden, aber auch manches nicht so gelaufen. Darum möchte ich mich für Sie im Stadtrat engagieren."
    },
    {
      id: 3,
      name: "Dr. Benno Bulitta",
      position: "Kandidat",
      age: 75,
      profession: "Dipl.-Volkswirt",
      image: "https://le-cdn.website-editor.net/f4f5b2f6065c4ec2b536c829d952713f/dms3rep/multi/opt/009+Dr.+Benno+Bulitta-1920w.jpeg",
      description: "Ich möchte mich unter anderem besonders für die Barrierefreiheit in Bad Windsheim und als ehemaliger Leiter des Kreisfremdenverkehrsamtes für die Förderung des Tourismus und der Gastronomie in unserer Stadt und in unserem Landkreis engagieren. Dabei darf ich auf 22 Jahre als Stadt-und Kreisrat zurückblicken und als 'Senior' meine Erfahrungen an die junge Generation weitergeben."
    },
    {
      id: 4,
      name: "Thomas Nölp",
      position: "Kandidat",
      age: 33,
      profession: "Industriemechaniker",
      image: "https://le-cdn.website-editor.net/f4f5b2f6065c4ec2b536c829d952713f/dms3rep/multi/opt/Thomas+N%C3%B6lp+kleiner-1920w.jpg",
      description: "Als Familienvater werde ich mich im Stadtrat für die Wohnungsvergabe bei städtischen Immobilien mit preiswerten Mieten vor allem kinderreiche Familien und für preiswerte kleinere Wohnungen für Senioren einsetzen. Auch soll Sorge dafür getragen werden, dass kommunale Immobilien auch regelmäßig gepflegt werden, zum Beispiel bei Schimmel und undichten Dächern."
    },
    {
      id: 5,
      name: "Ramona Nölp",
      position: "Kandidatin",
      age: 43,
      profession: "Verkäuferin",
      image: "https://le-cdn.website-editor.net/f4f5b2f6065c4ec2b536c829d952713f/dms3rep/multi/opt/Ramona-1920w.jpg",
      description: "Für eine ausgewogene Familienpolitik und für Kitas, in denen die Kinder noch Kinder sein dürfen. Keine ideologisch geprägten Erziehungsmaßnahmen, sondern echte und liebevolle Zuwendung. Den Waldkindergarten finde ich Spitze, weil die Kinder dort frühzeitig lernen, mit der Natur umzugehen und sich für die Bewahrung der Umwelt einzusetzen."
    },
    {
      id: 6,
      name: "Silvio Grube",
      position: "Kandidat",
      age: 46,
      profession: "Sicherheitsmitarbeiter",
      image: "https://le-cdn.website-editor.net/f4f5b2f6065c4ec2b536c829d952713f/dms3rep/multi/opt/Silvio+Bild-1920w.jpg",
      description: "Ich werde mich dafür einsetzen, dass unsere Straßen und Anlagen sicherer sind. Dazu gehören meines Erachtens auch eine Videoüberwachung und Aufzeichnungen, die bei einer Straftat verwendet werden können. Ich sehe darin eine Abschreckung, die dazu führen soll, dass diese Straftaten erst gar nicht vorkommen."
    },
    {
      id: 7,
      name: "Karen Wittich",
      position: "Kandidatin",
      age: 34,
      profession: "Sicherheitsmitarbeiterin",
      image: "https://le-cdn.website-editor.net/f4f5b2f6065c4ec2b536c829d952713f/dms3rep/multi/opt/Karen+Bild-1920w.jpg",
      description: "Ich muss immer an die Frauen denken, die in der Dunkelheit alleine unterwegs sein müssen. Deshalb ist für mich eine gute Straßenbeleuchtung notwendig. Dabei dürfen die Ortsteile auch nicht ausgeschlossen werden. Auch will ich mich dafür einsetzen, dass Frauen den Mut haben, Vorkommnisse zu melden. Dafür braucht es auch im Stadtrat Menschen mit Verständnis und Hilfsbereitschaft."
    },
    {
      id: 8,
      name: "Bennie Crawford",
      position: "Kandidat",
      age: 24,
      profession: "Baufinanzierungsberater",
      image: "https://static.readdy.ai/image/2461e108107748ba3465ce747c79b9cd/c79e98efbee9b89c3d670c5b0fbf4a33.png",
      description: "Damit Bad Windsheim für junge Menschen eine Heimat mit Zukunft bleibt, brauchen wir attraktiven Wohnraum statt schleichendem Verfall. Als aktiver Baufinanzierungsberater mache ich mich dafür stark, dass Wohnraum für uns Bürger geschaffen und unsere städtische Identität geschützt wird. Weiterhin setze ich mich konsequent dafür ein, dass Sicherheit und der Erhalt unserer Heimat bei jeder Entscheidung Vorrang haben."
    }
  ];

  useSEO({
    title: 'Stadtratskandidaten 2026 - AfD Bad Windsheim',
    description: 'Lernen Sie unsere engagierten Stadtratskandidaten für die Kommunalwahl 2026 in Bad Windsheim kennen. Dennis Neumeister, Monika Hartmann, Dr. Benno Bulitta und weitere Kandidaten stellen sich vor.',
    keywords: 'Stadtratskandidaten Bad Windsheim, AfD Kandidaten, Kommunalwahl 2026, Dennis Neumeister, Monika Hartmann',
    canonical: `${siteUrl}/kandidaten`,
    schema: {
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      name: 'Stadtratskandidaten AfD Bad Windsheim 2026',
      description: 'Unsere Kandidaten für den Stadtrat Bad Windsheim',
      itemListElement: stadtratCandidates.map((candidate, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        item: {
          '@type': 'Person',
          name: candidate.name,
          jobTitle: candidate.profession,
          age: candidate.age,
          image: candidate.image
        }
      }))
    }
  });

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative py-32 bg-gradient-to-br from-primary-600 to-primary-800 text-white overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{ backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'60\' height=\'60\' viewBox=\'0 0 60 60\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'none\' fill-rule=\'evenodd\'%3E%3Cg fill=\'%23ffffff\' fill-opacity=\'1\'%3E%3Cpath d=\'M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z\'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")' }}></div>
        </div>
        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <div className="inline-flex items-center gap-2 mb-6 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">
            <div className="w-2 h-2 bg-white rounded-full"></div>
            <span className="text-sm font-semibold tracking-wider uppercase">Unser Team</span>
          </div>
          <h1 className="text-5xl md:text-6xl font-bold mb-6">
            Stadtratskandidaten 2026
          </h1>
          <p className="text-xl text-primary-100 max-w-3xl">
            Lernen Sie unser engagiertes Team für den Stadtrat Bad Windsheim kennen. Jeder Kandidat bringt einzigartige Erfahrungen und Perspektiven ein.
          </p>
        </div>
      </section>

      {/* Team Photo */}
      <section className="py-16 bg-gradient-to-br from-gray-50 to-primary-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="rounded-2xl overflow-hidden shadow-2xl border-4 border-white">
            <img 
              src="https://le-cdn.website-editor.net/f4f5b2f6065c4ec2b536c829d952713f/dms3rep/multi/opt/Moni+ich+Dennis-1920w.jpeg"
              alt="Monika Hartmann, Dr. Benno Bulitta und Dennis Neumeister"
              className="w-full h-auto"
            />
          </div>
          <p className="text-center text-gray-600 mt-6 text-lg font-semibold">
            Monika Hartmann, Dr. Benno Bulitta und Dennis Neumeister
          </p>
        </div>
      </section>

      {/* Candidates Grid */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {stadtratCandidates.map((candidate) => (
              <div
                key={candidate.id}
                className="relative group cursor-pointer overflow-hidden rounded-xl shadow-lg hover:shadow-2xl transition-all duration-500 border-2 border-transparent hover:border-primary-300"
                onMouseEnter={() => setHoveredCandidate(candidate.id)}
                onMouseLeave={() => setHoveredCandidate(null)}
              >
                <div className="aspect-[3/4] relative">
                  <img
                    src={candidate.image}
                    alt={candidate.name}
                    className={`w-full h-full object-cover transition-transform duration-500 group-hover:scale-110 ${candidate.id === 8 ? 'object-[center_20%] scale-125' : 'object-top'}`}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-primary-900/90 via-primary-900/50 to-transparent"></div>
                  
                  {/* Default Info */}
                  <div className={`absolute bottom-0 left-0 right-0 p-6 text-white transition-all duration-500 ${hoveredCandidate === candidate.id ? 'opacity-0 translate-y-4' : 'opacity-100 translate-y-0'}`}>
                    <div className="text-2xl font-bold mb-1 text-secondary-400">{candidate.id < 10 ? `0${candidate.id}` : candidate.id}</div>
                    <h3 className="text-xl font-bold mb-2">{candidate.name}</h3>
                    <p className="text-sm text-gray-300">{candidate.age} Jahre</p>
                    <p className="text-sm text-gray-300">{candidate.profession}</p>
                  </div>

                  {/* Hover Info */}
                  <div className={`absolute inset-0 bg-gradient-to-br from-secondary-600 to-secondary-700 p-6 flex flex-col justify-start overflow-y-auto transition-all duration-500 ${hoveredCandidate === candidate.id ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-full'}`}>
                    <div className="text-white">
                      <div className="text-3xl font-bold mb-3">{candidate.id < 10 ? `0${candidate.id}` : candidate.id}</div>
                      <h3 className="text-2xl font-bold mb-2">{candidate.name}</h3>
                      <p className="text-sm mb-1 font-semibold">{candidate.age} Jahre</p>
                      <p className="text-sm mb-4 font-semibold">{candidate.profession}</p>
                      <p className="text-sm leading-relaxed">{candidate.description}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Voting Info */}
      <section className="py-24 bg-primary-900 text-white">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <div className="inline-flex items-center gap-2 mb-6 bg-secondary-600 px-4 py-2 rounded-full">
            <i className="ri-information-line"></i>
            <span className="text-sm font-semibold tracking-wider uppercase">Wichtig</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            So unterstützen Sie unser Team
          </h2>
          <p className="text-xl mb-8 text-primary-200 leading-relaxed">
            Bitte kreuzen Sie einfach die <span className="text-secondary-400 font-bold">Liste 3 - AfD</span> oben an, dann erhält jeder Kandidat drei Stimmen und Sie haben Ihr volles Stimmen-Potenzial von <span className="text-secondary-400 font-bold">24 Stimmen</span> ausgenutzt.
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <Link 
              to="/stadtratswahl" 
              className="bg-secondary-600 hover:bg-secondary-700 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer shadow-lg"
            >
              Mehr zur Stadtratswahl
            </Link>
            <Link 
              to="/" 
              className="bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white border-2 border-white px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Zurück zur Startseite
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default KandidatenPage;
